module.exports = __webpack_public_path__ + "img/icon97.751b6271.png";